export default "__VITE_ASSET__1e77cf51__"